import { handleClientError } from "./errors";

const conversionEvents = new Set([
  "Demo Form Submitted",
  "Whitepaper Downloaded",
  "Sign Up Clicked",
  "Log In Clicked",
  "Newsletter Signup",
]);

type Data = { [key in string]?: string | number | boolean | undefined | Data | Data[] };

export const track = (event: string, properties: Data = {}) => {
  const context = { migrationId: getMigrationId() };

  if (window.htevents) {
    void window.htevents.track(event, properties, context);
  }

  // Track conversion events in Reddit
  if (window.rdt && conversionEvents.has(event)) {
    window.rdt("track", "Custom", { customEventName: event, ...properties });
  }
};

export const identify = (userId: string | undefined, traits: Data) => {
  const context = { migrationId: getMigrationId() };

  if (window.htevents) {
    void window.htevents.identify(userId, traits, context);
  }

  const { email, ...properties } = traits;
  const userProperties = { ...properties, userId };

  if (window.ko && email) {
    window.ko.identify(email, userProperties);
  }
};

export const group = (groupId: string) => {
  const context = { migrationId: getMigrationId() };

  if (window.htevents) {
    void window.htevents.group(groupId, {}, context);
  }
};

const getUserId = async (): Promise<string> => {
  if (window.htevents) {
    const user = await window.htevents.user();
    return user.id()?.toString() ?? "";
  }

  return "";
};

const getAnonymousId = async (): Promise<string> => {
  if (window.htevents) {
    const user = await window.htevents.user();
    return user.anonymousId()?.toString() ?? "";
  }

  return "";
};

export const trackEvent = (event: string, properties: Data = {}) => {
  track(event, properties);
};

export const identifyUser = (properties: Data = {}): void => {
  if (window.htevents) {
    void getUserId().then((userId: string) => {
      identify(userId === "" ? undefined : userId, properties);
    });
  }
};

const mutinyTrack = (name: string) => {
  if (window.mutiny.client) {
    window.mutiny.client.trackConversion({ name });
  }
};

export const trackMutinyConversion = (name: string) => {
  mutinyTrack(name);
};

// Push an event to the Google Tag Manager dataLayer with the corresponding htevents anonymousId
export const dataLayerPush = (event: string) => {
  void getAnonymousId()
    .then((anonymousId: string) => {
      window.dataLayer?.push({
        event,
        anonymousId,
      });
    })
    .catch((error) => {
      handleClientError(`Error getting anonymousId: ${error}`);
      window.dataLayer?.push({
        event,
        anonymousId: undefined,
      });
    });
};

// Returns a random ID that can be used to join events across Rudderstack and
// Hightouch in the backend.
function getMigrationId(): string {
  const timestamp = Date.now();
  const randomness = Math.floor(Math.random() * 1000);
  return `${timestamp}-${randomness}`;
}
